balances = {
    label: 'Soldes de congés'
    access_set: ['balance_edit']
    tables_count: 1
    fields:
        user_reference:
            label: 'Référence externe collaborateur *'
            format: 'Chaine de caractères alphanumériques, limitée à 255'
            help: 'Ce champ permet à l\'import de retrouver le collaborateur concerné par ce solde'
            required: true
        counter_name:
            label: 'Référence du compteur *'
            format: [{'old_ref':'cp_n1_a', 'label':'Congés payés acquis année n-1'},
                {'old_ref':'cp_n1_p', 'label': 'Congés payés pris année n-1'},
                {'old_ref':'cp_n_a', 'label': 'Congés payés acquis année n'},
                {'old_ref':'cp_n_p', 'label': 'Congés payés pris année n'},
                {'old_ref':'cp_anc_a', 'label': 'Congés payés ancienneté acquis'},
                {'old_ref':'cp_anc_p', 'label': 'Congés payés ancienneté pris'},
                {'old_ref':'cp_sup1_a', 'label': 'Congés payés supplémentaires 1 acquis'},
                {'old_ref':'cp_sup1_p', 'label': 'Congés payés supplémentaires 1 pris'},
                {'old_ref':'cp_sup2_a', 'label': 'Congés payés supplémentaires 2 acquis'},
                {'old_ref':'cp_sup2_p', 'label': 'Congés payés supplémentaires 2 pris'},
                {'old_ref':'rtt_a', 'label': 'RTT acquis'},
                {'old_ref':'rtt_p', 'label': 'RTT pris'},
                {'old_ref':'rco_a', 'label': 'Repos Compensateur Obligatoire acquis'},
                {'old_ref':'rco_p', 'label': 'Repos Compensateur Obligatoire pris'},
                {'old_ref':'rco_s', 'label': 'Repos Compensateur Obligatoire solde'},
                {'old_ref':'rcr_a', 'label': 'Repos Compensateur de Remplacement acquis'},
                {'old_ref':'rcr_p', 'label': 'Repos Compensateur de Remplacement pris'},
                {'old_ref':'rcr_s', 'label': 'Repos Compensateur de Remplacement solde'},
                {'old_ref':'cet_a', 'label': 'Compte Épargne Temps acquis'},
                {'old_ref':'cet_p', 'label': 'Compte Épargne Temps pris'},
                {'old_ref':'rfj_a', 'label': 'Repos Forfait Jour acquis'},
                {'old_ref':'rfj_p', 'label': 'Repos Forfait Jour pris'},
            ]
            required: true
        nb_days:
            label: 'Nombre de jours/heures *'
            format: 'Nombre décimal avec un point comme séparateur (ex : 12.5)'
            help: 'Seuls les Repos Complémentaires doivent être en heures.'
            required: true
}

establishments = {
    label: 'Établissements'
    access_set: ['establishments_edit']
    tables_count: 2
    fields:
        name:
            label: 'Nom *'
            format: 'Chaine de caractères alphanumériques, limitée à 255'
            required: true
        siret:
            label: 'Siret'
            format: 'Chaine de caractères alphanumériques, limitée à 100'
        address:
            label: 'Adresse'
            format: 'Chaine de caractères alphanumériques, limitée à 255'
        address2:
            label: 'Adresse 2'
            format: 'Chaine de caractères alphanumériques, limitée à 255'
        zipcode:
            label: 'Code postal'
            format: 'Chaine de caractères alphanumériques, limitée à 50'
        city:
            label: 'Ville'
            format: 'Chaine de caractères alphanumériques, limitée à 255'
        phone:
            label: 'Téléphone'
            format: 'Chaine de caractères alphanumériques, limitée à 50'
        email:
            label: 'Email'
            format: 'Adresse email'
}

companies = {
    label: 'Sociétés'
    access_set: ['*']
    tables_count: 2
    fields:
        legal_form:
            label: 'Forme *'
            required: true
            format: 'earl, gaec, gie, sarl, sa, sas, sasu, scop, sel, autre'
        name:
            label: 'Nom *'
            format: 'Chaine de caractères alphanumériques, limitée à 255'
            required: true
        reference:
            label: 'Référence externe'
            format: 'Chaine de caractères alphanumériques, limitée à 255'
            help: 'Si le champ référence externe est renseigné, il permet à l\'import de retrouver la société afin de mettre à jour ses données'
        ape_naf_code:
            label: 'Code NAF / APE'
            format: 'Chaine de caractères alphanumériques, limitée à 100'
        siret:
            label: 'Siret'
            format: 'Chaine de caractères alphanumériques, limitée à 100'
        employees_nb:
            label: 'Nombre de salariés'
            format: 'Nombre entier'
        address:
            label: 'Adresse'
            format: 'Chaine de caractères alphanumériques, limitée à 255'
        address2:
            label: 'Adresse 2'
            format: 'Chaine de caractères alphanumériques, limitée à 255'
        zipcode:
            label: 'Code postal'
            format: 'Chaine de caractères alphanumériques, limitée à 50'
        city:
            label: 'Ville'
            format: 'Chaine de caractères alphanumériques, limitée à 255'
        phone:
            label: 'Téléphone'
            format: 'Chaine de caractères alphanumériques, limitée à 50'
        email:
            label: 'Email'
            format: 'Adresse email'
}

users = {
    label: 'Collaborateurs'
    access_set: ['users_edit']
    tables_count: 4
    fields:
        email:
            label: 'Email *'
            format: 'Adresse email'
            required: true
        reference:
            label: 'Référence externe'
            format: 'Chaine de caractères alphanumériques, limitée à 255'
            help: 'Si le champ référence externe est renseigné, il permet à l\'import de retrouver le collaborateur afin de mettre à jour ses données'
        gender:
            label: 'Civilité'
            format: 'h ou f'
        firstname:
            label: 'Prénom *'
            format: 'Chaine de caractères alphanumériques, limitée à 255'
            required: true
        lastname:
            label: 'Nom *'
            format: 'Chaine de caractères alphanumériques, limitée à 255'
            required: true
        birthday:
            label: 'Date de naissance'
            format: 'jj/mm/aaaa'
        nationality:
            label: 'Nationalité'
            format: 'Chaine de caractères alphanumériques, limitée à 255'
        title_of_stay:
            label: 'Titre de séjour'
            format: 'oui ou non'
        title_of_stay_name:
            label: 'Intitulé du document d\'autorisation (* si oui)'
            format: 'Chaine de caractères alphanumériques, limitée à 255'
        title_of_stay_number:
            label: 'N° d\'ordre du document d\'autorisation (* si oui)'
            format: 'Chaine de caractères alphanumériques, limitée à 255'
        title_of_stay_validity:
            label: 'Date de validité du titre de séjour (* si oui)'
            format: 'jj/mm/aaaa'
        address:
            label: 'Adresse'
            format: 'Chaine de caractères alphanumériques, limitée à 255'
        address2:
            label: 'Adresse 2'
            format: 'Chaine de caractères alphanumériques, limitée à 255'
        zipcode:
            label: 'Code postal'
            format: 'Chaine de caractères alphanumériques, limitée à 50'
        city:
            label: 'Ville'
            format: 'Chaine de caractères alphanumériques, limitée à 255'
        phone:
            label: 'Téléphone'
            format: 'Chaine de caractères alphanumériques, limitée à 50'
        social_nbr:
            label: 'Numéro de sécurité sociale'
            format: 'Chaine de caractères alphanumériques, limitée à 15'
        medical_visit:
            label: 'Date prochaine visite médicale'
            format: 'jj/mm/aaaa'
        sir:
            label: 'SIR'
            format: 'oui ou non'
        rqth:
            label: 'Reconnaissance RQTH'
            format: 'oui ou non'
        rqth_end:
            label: 'Date de fin RQTH'
            format: 'jj/mm/aaaa'
}

user_salaries = {
    label: 'Rémunérations'
    access_set: ['user_salaries_edit']
    tables_count: 1
    fields:
        user_reference:
            label: 'Référence externe collaborateur *'
            format: 'Chaine de caractères alphanumériques, limitée à 255'
            help: 'Ce champ permet à l\'import de retrouver le collaborateur concerné par cette rémunération'
            required: true
        period:
            label: 'Date *'
            format: 'jj/mm/aaaa'
            required: true
        base:
            label: 'Salaire de base *'
            format: 'Nombre décimal avec un point comme séparateur (ex : 12.5)'
            required: true
        bonus:
            label: 'Prime'
            format: 'Nombre décimal avec un point comme séparateur (ex : 138.75)'
}

users_jobs = {
    label: 'Contrats'
    access_set: ['users_jobs_edit', 'jobs_edit']
    tables_count: 3
    fields:
        user_reference:
            label: 'Référence externe collaborateur *'
            format: 'Chaine de caractères alphanumériques, limitée à 255'
            help: 'Ce champ permet à l\'import de retrouver le collaborateur concerné par ce contrat'
            required: true
        reference:
            label: 'Référence externe'
            format: 'Chaine de caractères alphanumériques, limitée à 255'
            help: 'Si le champ référence externe est renseigné, il permet à l\'import de retrouver le contrat afin de mettre à jour ses données'
        service_name:
            label: 'Service'
            format: 'Chaine de caractères alphanumériques, limitée à 255'
        job_name:
            label: 'Métier *'
            format: 'Chaine de caractères alphanumériques, limitée à 255'
            required: true
        start:
            label: 'Début *'
            format: 'jj/mm/aaaa'
            required: true
        end:
            label: 'Fin'
            format: 'jj/mm/aaaa'
        establishments_siret:
            label: 'Établissements'
            format: 'SIRET séparés par un tiret (ex : 36252187900034-36252187900024)'
        contract_type_id:
            label: 'Type de contrat *'
            format: [{'old_ref':0, 'label':'CDI'},
                {'old_ref':1, 'label': 'Avenant'},
                {'old_ref':2, 'label': 'CDD'},
                {'old_ref':3, 'label': 'CDD d’usage'},
                {'old_ref':4, 'label': 'Travail temporaire'},
                {'old_ref':5, 'label': 'Groupement d\'employeur'},
                {'old_ref':6, 'label': 'Apprentissage'},
                {'old_ref':7, 'label': 'Professionnalisation'},
                {'old_ref':8, 'label': 'Intermittent'},
                {'old_ref':9, 'label': 'Convention de stage'},
                {'old_ref':9999, 'label': 'Autre'}
            ]
            required: true
        status:
            label: 'Statut *'
            format: [
                {'old_ref':0, 'label':'Ouvrier'},
                {'old_ref':1, 'label':'Employé'},
                {'old_ref':2, 'label':'Technicien'},
                {'old_ref':3, 'label':'Cadre'},
                {'old_ref':4, 'label':'Ingénieur'},
                {'old_ref':5, 'label':'Agent de maîtrise'},
                {'old_ref':6, 'label':'Stagiaire'},
                {'old_ref':7, 'label':'Dirigeant'},
                {'old_ref':9999, 'label':'Autre'}
            ]
            required: true
        weekly_hours:
            label: 'Nombre d\'heures hebdomadaires'
            format: 'Nombre décimal avec un point comme séparateur (ex : 30.25)'
        partial_time:
            label: 'Travail à temps partiel'
            format: 'oui ou non'
        idcc:
            label: 'IDCC'
            format: 'Chaine de caractères alphanumériques, limitée à 255'
        employer_name:
            label: 'Nom de l\'employeur'
            format: 'Chaine de caractères alphanumériques, limitée à 255'
        employer_address:
            label: 'Adresse de l\'employeur'
            format: 'Chaine de caractères alphanumériques, non limitée'
        organization_name:
            label: 'Nom de l\'établissement ou de l\'organisme'
            format: 'Chaine de caractères alphanumériques, limitée à 255'
        tutor_name:
            label: 'Nom du tuteur'
            format: 'Chaine de caractères alphanumériques, limitée à 255'
}

export default{
    establishments: establishments
    companies: companies
    users: users
    user_salaries: user_salaries
    users_jobs: users_jobs
    balances: balances
}